import { AxiosInstance } from 'axios'
import { useAuditStore } from '@/stores/audit'

import { RequestError } from '@/types/error'
import { Initialize, initializeInternalChat, MessageUserChat, payloadAudit } from '@/types/internalChatAxios'


export interface InternalChatServiceInterface {
    initialize(): Promise<Initialize>;
    findMessage(payload: payloadAudit): Promise<MessageUserChat>;
}

function audit (httpClient: AxiosInstance): InternalChatServiceInterface {
  async function initialize (): Promise<Initialize> {
    const auditStore = useAuditStore()
    const response = await httpClient.get<initializeInternalChat>('internal-chat/initialize/audit', auditStore.config)

    let errors: RequestError | null = null

    if (!response.data) {
      const error = JSON.parse(response.request.response)
      errors = {
        status: response.request.status,
        statusText: response.request.statusText,
        message: error.message
      }
    }
    return {
      data: response.data?.data ?? null,
      errors
    }
  }
  async function findMessage (payload: payloadAudit ): Promise<MessageUserChat> {
    const auditStore = useAuditStore()
    const response = await httpClient.post(`internal-chat/audit`, payload, auditStore.config)
    let errors: RequestError | null = null

    if (!response.data) {
      errors = {
        status: response.request.status,
        statusText: response.request.statusText
      }
    }
    return {
      data: response.data,
      errors
    }
  }
  return {
    initialize, findMessage
  }
}

export default audit
